export const icclrFormConfig = {
  metadata: {
    title: "ICCLR Aanmeldformulier",
    defDossier: 4471,
    environment: 334,
    linkedDossier: 4472,
    linkDisplayPosition: 18898,
    linkFieldId: 90886,
    brandColors: {
      primary: "#f97316",
      primaryDark: "#ea580c",
      primaryLight: "#fb923c",
      accent: "#f97316",
      success: "#22c55e",
      neutral: "#f8f9fa",
      text: "#212529",
      textLight: "#6c757d",
      border: "#e5e7eb",
    },
    fieldMapping: {
      voornaam: { aanmeldigen: 90845, personen: 90909 },
      achternaam: { aanmeldigen: 90846, personen: 90906 },
      geslacht: { aanmeldigen: 90847, personen: 90907, transform: "selectArray" },
      phone_persoon: { aanmeldigen: 90848, personen: 90908 },
      email_melder: { aanmeldigen: 90851, personen: 90911 },
      postcode: { aanmeldigen: 90852, personen: 90912 },
      huisnummer: { aanmeldigen: 90853, personen: 90913 },
      straat: { aanmeldigen: 90854, personen: 90914 },
      geboortedatum_melding: { personen: 90916 },
      lidmaatschap: { aanmeldigen: 90858, transform: "checkboxArray" },
      privacy: { aanmeldigen: 90857, transform: "checkboxArray" },
      contributie: { aanmeldigen: 90856, transform: "checkboxArray" },
    },
    autoFields: {
      aanmeldigen: { 90861: "today", 93408: null },
      personen: { 93408: null },
    },
  },

  sections: [
    {
      id: "aanmeldformulier",
      title: "Aanmeldformulier",
      hideTitle: true,
      description: "Lidmaatschap is alleen voor volwassenen.",
      layout: {
        columns: { default: 1, sm: 2, lg: 4 },
        gap: "gap-4",
      },
      fields: [
        {
          id: "voornaam",
          name: "voornaam",
          type: "text",
          label: "Voornaam",
          required: true,
          columnSpan: { default: 1 },
          validation: { required: "This field is required" },
        },
        {
          id: "achternaam",
          name: "achternaam",
          type: "text",
          label: "Achternaam",
          required: true,
          columnSpan: { default: 1 },
          validation: { required: "This field is required" },
        },
        {
          id: "geslacht",
          name: "geslacht",
          type: "select",
          label: "Geslacht:",
          required: true,
          columnSpan: { default: 1 },
          options: [
            { value: "45935", label: "Vrouw" },
            { value: "45934", label: "Man" },
          ],
          validation: { required: "This field is required" },
        },
        {
          id: "phone_persoon",
          name: "phone_persoon",
          type: "phone",
          label: "Telefoonnummer",
          required: true,
          columnSpan: { default: 1 },
          validation: { required: "This Field Is Required" },
        },
        {
          id: "email_melder",
          name: "email_melder",
          type: "email",
          label: "E-mailadres",
          required: true,
          columnSpan: { default: 1 },
          validation: {
            required: "Email is required",
            pattern: { value: /^\S+@\S+$/i, message: "Invalid email address" },
          },
        },
        {
          id: "postcode",
          name: "postcode",
          type: "text",
          label: "Postcode",
          required: true,
          columnSpan: { default: 1 },
          validation: { required: "This field is required" },
        },
        {
          id: "huisnummer",
          name: "huisnummer",
          type: "text",
          label: "Huisnummer",
          required: true,
          columnSpan: { default: 1 },
          validation: { required: "This field is required" },
        },
        {
          id: "straat",
          name: "straat",
          type: "text",
          label: "Straat",
          required: false,
          columnSpan: { default: 1 },
          validation: {},
        },
        {
          id: "geboortedatum_melding",
          name: "geboortedatum_melding",
          type: "date",
          label: "Geboortedatum",
          required: true,
          columnSpan: { default: 1 },
          validation: { required: "This Field required" },
        },
        {
          id: "lidmaatschap",
          name: "lidmaatschap",
          type: "checkbox-group",
          label: "Naast lidmaatschap is mijn doel van aanmelding ook van toepassing op:",
          required: false,
          columnSpan: { default: 1, sm: 2, lg: 4 },
          options: [
            { value: "45942", label: "Vrijwilliger worden" },
            { value: "45943", label: "Inschrijven onderwijs" },
          ],
          validation: {},
        },
        {
          id: "privacy",
          name: "privacy",
          type: "checkbox-group",
          label: "Privacy",
          required: true,
          columnSpan: { default: 1, sm: 2, lg: 4 },
          options: [
            { value: "45933", label: "Ik ga akkoord met de privacyverklaring van ICCLR" },
          ],
          validation: {
            required: "field is required",
          },
        },
        {
          id: "contributie",
          name: "contributie",
          type: "checkbox-group",
          label: "Contributie",
          required: true,
          columnSpan: { default: 1, sm: 2, lg: 4 },
          options: [
            {
              value: "45933",
              label: "Ik ga akkoord met het betalen van de maandelijkse contributie van \u20AC15,- per maand",
            },
          ],
          validation: {
            required: "field is required",
          },
        },
      ],
    },
  ],

  progress: {
    enabled: false,
    trackRequiredFields: false,
  },

  autoSave: {
    enabled: false,
  },

  submission: {
    submitButton: {
      text: "Lid worden",
      requireAllRequired: true,
    },
  },

  styling: {
    fonts: {
      primary: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      size: { small: "12px", base: "14px", large: "16px" },
    },
    spacing: { small: "8px", base: "12px", medium: "16px", large: "24px" },
    borderRadius: { small: "4px", base: "4px", large: "8px" },
    shadows: {
      small: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
      medium: "0 4px 6px -1px",
      large: "0 8px 15px -3px",
    },
    transitions: {
      fast: "all 0.2s ease-in-out",
      medium: "all 0.3s ease-out",
    },
    title: { fontWeight: 400, fontSize: "18px" },
    label: {
      fontSize: "14px",
      fontWeight: "bold",
      lineHeight: "1.4",
      marginTop: "0",
      marginBottom: "4px",
      textAlign: "left",
    },
    input: {
      display: "block",
      width: "100%",
      padding: "4px 8px",
      fontSize: "14px",
      fontWeight: "400",
      lineHeight: "1.5",
      backgroundColor: "#f9fafb",
      border: "1px solid #d1d5db",
      height: "32px",
      borderRadius: "4px",
      transition: "all 0.2s ease-in-out",
    },
    checkbox: {
      width: "auto",
      fontSize: "14px",
      fontWeight: "400",
      lineHeight: "1.2",
      border: "none",
      height: "26px",
      borderRadius: "4px",
      boxShadow: "none",
    },
    radio: {
      width: "auto",
      fontSize: "14px",
      fontWeight: "400",
      lineHeight: "1.2",
      border: "none",
      height: "26px",
      borderRadius: "4px",
      boxShadow: "none",
    },
    textarea: { height: "120px", resize: "vertical", minHeight: "120px" },
    select: {
      control: {
        border: "1px solid #d1d5db",
        borderRadius: "4px",
        minHeight: "32px",
        backgroundColor: "#f9fafb",
      },
      placeholder: { color: "#6b7280" },
      valueContainer: { padding: "0 8px" },
    },
    button: {
      background: "linear-gradient(135deg)",
      color: "white",
      fontWeight: "700",
      padding: "8px 24px",
      borderRadius: "24px",
      border: "none",
      fontSize: "14px",
      transition: "all 0.3s ease-in-out",
    },
  },
};

export default icclrFormConfig;
